import service_1 from '@/assets/img/contact/serve-1.jpg'
import service_2 from '@/assets/img/contact/serve-2.jpg'
import service_3 from '@/assets/img/contact/serve-3.jpg'
import service_4 from '@/assets/img/contact/serve-4.jpg'

export interface ServiceProps {
  title: string
  list: {
    title: string
    description: string
    image: string
  }[]
}

export const servicesEn: ServiceProps = {
  title: 'Specialty Mobile Energy Solutions',
  list: [
    {
      title: 'Environmental Construction and Hazardous Removal',
      description:
        'Experts in hazardous material removal, including asbestos and lead abatement, meeting compliance with EPA, AQMD, OSHA, and city codes.',
      image: service_1,
    },
    {
      title: 'General Construction',
      description: 'Comprehensive building and development services',
      image: service_2,
    },
    {
      title: 'Flooring and Waterproofing Solutions',
      description:
        'Specialists in epoxy flooring, antimicrobial flooring, and advanced waterproofing systems, protect structures from moisture intrusion and extend lifespan.',
      image: service_3,
    },
    {
      title: 'Disaster Relief and Restoratio',
      description:
        'Skilled in fire and smoke damage restoration, water damage restoration, microbial remediation, and biohazard remediation.',
      image: service_4,
    },
  ],
}
